export enum StreamDownloadState {
    OK,
    REDIRECT, 
    FAILURE
  }